export default __webpack_public_path__ + "static/Banner_Exhibition_0-5a6d816a634b1159aa954eb23a302589.png";